import React from "react";
import { Box } from '@mui/material'
import Header from './Header';
import Main from './Main';
import Footer from './Footer';
import Navbar from "./Navbar";

const Container = () => {
  return (
    <Box>
      <Header />
      <Navbar />
      <Main />
      <Footer />
    </Box>
  );
};

export default Container;


